export const conceptNames = {
  delivery_method_fee_amount: 'Logística (costes devolución)',
  carbon_offset_fee_amount: 'Compensación huella carbono',
  instant_fee_amount: 'Comisión reembolso instantáneo',
  rule_fee_amount: 'Comisión tipo de producto',
  shipping_amount: 'Gastos de envío originales',
  original_amount: 'Productos',
  exchange_items_refund_amount: 'Productos solicitados',
}

export const customLogisticsLabelConcept = 'delivery_method_fee_amount'

export const labeledAmountsKey = 'labeled_amounts'
